import { forwardRef, type TextareaHTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

export const Textarea = forwardRef<
  HTMLTextAreaElement,
  TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => {
  return (
    <textarea
      ref={ref}
      className={cn('input-luxury store-input focus-ring resize-y min-h-[120px]', className)}
      {...props}
    />
  )
})
Textarea.displayName = 'Textarea'
